module.exports = __webpack_public_path__ + "img/collar button diameter.12cca01d.png";